export default {
  profileInfo: null,
};